import React, { useEffect, useState } from "react";
import Select from "react-select";
import "./AddDiscordChannelModal.css";

const AddDiscordChannelModal = ({ isOpen, onClose, onCreate, availableVariants, tripData }) => {
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [name, setName] = useState("");
  const emoji = "🌄";

  const formatDate = (iso) => {
    const date = new Date(iso);
    return date
      .toLocaleDateString("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replaceAll(".", "-");
  };

  useEffect(() => {
    if (tripData && isOpen) {
      const tripName = tripData.name?.toLowerCase().replace(/\s+/g, "-") || "wycieczka";
      const tripStartDate = tripData.variants?.[0]?.startDate || null;
      const formattedDate = tripStartDate ? formatDate(tripStartDate) : "data";
      setName(`${emoji}${tripName}-${formattedDate}`);
    }
  }, [tripData, isOpen]);

  const handleChange = (e) => {
    const input = e.target.value;

    if (!input.startsWith(emoji)) {
      setName(`${emoji}${input.replaceAll(emoji, "").trimStart()}`);
    } else {
      setName(input);
    }
  };

  const handleSubmit = () => {
    if (!name.trim() || selectedVariants.length === 0) return;
    onCreate(name.trim(), selectedVariants.map((v) => v.value));
    setSelectedVariants([]);
    setName("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modall-overlay">
      <div className="modall-content">
        <h3>Utwórz nowy kanał Discord</h3>
        <p className="variant-info">
          Każdy wariant może być powiązany maksymalnie z jednym kanałem. W liście rozwijanej
          znajdują się tylko dostępne (niepowiązane) warianty.
        </p>

        <input
          type="text"
          value={name}
          onChange={handleChange}
          placeholder="Nazwa kanału"
        />

        <Select
          isMulti
          value={selectedVariants}
          onChange={setSelectedVariants}
          options={availableVariants.map((v) => ({
            value: v.guid,
            label: v.name,
          }))}
          placeholder="Powiąż z wariantami"
        />

        <div className="modall-actions">
          <button className="btn-cancel" onClick={onClose}>
            Anuluj
          </button>
          <button className="btn-create" onClick={handleSubmit}>
            Utwórz
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDiscordChannelModal;
